/**
 * Reinicio de la animación de entrada del mega menú.
 *
 * Las animaciones CSS colgadas de `.mega-menu[open]` solo se disparaban de
 * forma confiable en el primer panel abierto tras cargar la página: al reabrir
 * —o al abrir otro panel— el navegador conserva la animación terminada y no la
 * recrea. (Dawn tiene un rescate para esto en `DetailsDisclosure.onToggle`,
 * pero `HeaderMenu` sobreescribe ese método sin llamar a super.)
 *
 * La coreografía vive ahora en la clase `.is-entering`, y aquí se reinicia con
 * la técnica estándar: quitar la clase, forzar un reflow y volver a ponerla.
 * Determinista en cada apertura. Con prefers-reduced-motion la clase no tiene
 * animaciones asociadas, así que esto queda inerte.
 */
(function () {
  'use strict';

  var ENTER_CLASS = 'is-entering';

  function restart(details) {
    var content = details.querySelector('.mega-menu__content');
    if (!content) return;

    content.classList.remove(ENTER_CLASS);
    if (!details.open) return;

    void content.offsetWidth; // reflow: obliga al navegador a reiniciar la animación
    content.classList.add(ENTER_CLASS);
  }

  function init() {
    document.querySelectorAll('.mega-menu').forEach(function (details) {
      details.addEventListener('toggle', function () {
        restart(details);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
